exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ResetAllButton{height:32px;border-radius:4px;user-select:none;cursor:pointer;transition:opacity 250ms linear}.ResetAllButton.pressed{opacity:.2}", ""]);
